import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { MdIntegrationInstructions, MdPointOfSale, MdSettingsEthernet, MdCode, MdStorefront } from 'react-icons/md';
import POSIntegration from './POSIntegration';
import IntegrationsSettings from "./IntegrationsSettings";
import CustomIntegratorPanel from "./CustomIntegratorPanel";
import RetailerInstallations from './RetailerInstallations';
import PageContainer from '../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../shared/layout/titles/PageTitle';
import PageContent from '../../../shared/layout/containers/PageContent';
import TabBar from '../../../shared/layout/tabs/TabBar';
import TabButton from '../../../shared/layout/tabs/TabButton';

const Integrations = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const [activeTab, setActiveTab] = useState(params.get('tab') === 'custom' ? 'custom' : 'stores');

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle icon={<MdIntegrationInstructions size={28} />}>{t('Settings.Integrations.title')}</PageTitle>
                <Link to="/setup">{t('RetailerSetup.resume')}</Link>
            </PageHeader>

            <PageContent>
                <TabBar>
                    <TabButton active={activeTab === 'stores'} onClick={() => setActiveTab('stores')} icon={<MdStorefront />}>
                        {t('Settings.Integrations.retailer.tab')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'general'}
                        onClick={() => setActiveTab('general')}
                        icon={<MdSettingsEthernet />}
                    >
                        {t('Settings.Integrations.general')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'pos'}
                        onClick={() => setActiveTab('pos')}
                        icon={<MdPointOfSale />}
                    >
                        {t('Settings.Integrations.pos')}
                    </TabButton>
                    <TabButton
                        active={activeTab === 'custom'}
                        onClick={() => setActiveTab('custom')}
                        icon={<MdCode />}
                    >
                        Custom API & Webhooks
                    </TabButton>
                </TabBar>

                <div style={{ marginTop: '24px' }}>
                    {activeTab === 'stores' && <RetailerInstallations />}
                    {activeTab === 'general' && (
                        <IntegrationsSettings />
                    )}

                    {activeTab === 'pos' && (
                        <POSIntegration />
                    )}

                    {activeTab === 'custom' && (
                        <CustomIntegratorPanel />
                    )}
                </div>
            </PageContent>
        </PageContainer>
    );
};

export default Integrations;
